/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_PUBLIC } from '../../../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useHistory } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import {decode} from 'html-entities';
import {reactLocalStorage} from 'reactjs-localstorage';
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Redux]
-------------------------------------------------------------------*/
import {useSelector, useDispatch} from 'react-redux';
import { _action_user } from '../../../../../redux/store';
/*------------------------------------------------------------------
[End Redux]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Style]
-------------------------------------------------------------------*/
import '../../../../../style/general/node.entry.css';
/*------------------------------------------------------------------
[End Style]
-------------------------------------------------------------------*/

import { random_character, countDown } from '../../../../../functions'

const Screen = ({loading, error, location}) => {

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/

    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}

    const [username, set_username] = useState('');

    const [refresh, set_refresh] = useState(false);

    const [second, set_second] = useState(0);

	//#region redux ------------------------------------------------

	const dispatch = useDispatch();

    const redux_user = useSelector(state => state.user);

	const _set_redux_user = (data) => {
		dispatch(_action_user(data, 'data'))
	}

	//#endregion redux ---------------------------------------------

    if(STORAGE_USER !== undefined){
        history.push('/')
    }else{
        history.push('/')
    }

    const _send = () => {

        if(loading === true){
            return
        }

		loading(true);

		API_GET_PUBLIC('simpr/bprb/activation__________?key=' + random_character(32)
			+ '&action=send'
            + '&username=' + username
        , 
	    ).then((response) => {
            console.log('------', response.data)
			if(response.data.result === 'success'){
                countDown('30', (e) => {
                    set_second(e)
                })
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
			loading(false)
		})

    }

    const _activation = (usernameParams) => {

        console.log('username params : ', usernameParams)

        if(loading === true){
            return
        }

		loading(true);

		API_GET_PUBLIC('simpr/bprb/activation__________?key=' + random_character(32)
			+ '&action=verification'
            + '&username=' + usernameParams 
        , 
	    ).then((response) => {
            console.log('------', response)
			if(response.data.result === 'success'){
                reactLocalStorage.clear();
                _set_redux_user('')
                set_refresh(false)
            }else if(response.data.error){
                // error(response.data.error)
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
			loading(false)
		})

    }

    const _STORAGE_USER = () => {

        if(STORAGE_USER !== undefined){

            let username = STORAGE_USER[0].username;
            
            if(username){
                _activation(username)
                set_username(username)
            }

        }

    }
    
    useEffect(() => {

        _STORAGE_USER()

        // console.log('asdkkasdk')

    }, [refresh])

    return (
        <>
            <div className="_bb-background"></div>
            <div className="_bb_background_2"></div>
            <div className="_container _relative">
                <div className="__section_pages_title">
                    <div className="_row _center_align _lily_pad_h_d">
                        <div className="_column">
                            <h1>Aktivasi</h1>
                            <p>Periksa email kamu untuk menemukan link aktivasi.</p>
                            <br/>
                            {
                                second > 0 ?
                                    <p>Kirim ulang email setelah {second}</p>
                                :
                                    <>
                                        <button onClick={() => _send()} className="_btn _push_r_m">Kirim Ulang</button>
                                        <button onClick={() => {
                                            reactLocalStorage.clear();
                                            window.location.reload();
                                        }} className="_btn">Keluar</button>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default Screen;